/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";

import * as styles from "./TestStyle.module.css";

type TestLogsDisplayProps = Readonly<{
  testLogs?: string[];
}>;

export const TestLogsDisplay = ({ testLogs }: TestLogsDisplayProps) => {
  if (!testLogs) {
    return null;
  }
  return (
    <div className={styles.crmDataDisplay}>
      <h3>Server logs</h3>
      <div className={styles.crmDataListWrapper}>
        <div className={styles.forms}>
          {testLogs.map((log, index) => (
            <div key={`testlog-${index}`}>{log}</div>
          ))}
        </div>
      </div>
    </div>
  );
};
